import React, { useEffect, useState } from "react";
import "./App.css";
import IndikatorKankerAnak from "./Form/IndikatorForm";
import { Spin, Card } from "antd";
import background from "./assets/rsms_blur.jpg";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500); // 2.5 detik
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {loading ? (
        <div
          className="splash-screen"
          style={{
            minHeight: "100vh",
            backgroundImage: `url(${background})`,

            // backgroundImage:
            // "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <Card
            style={{
              textAlign: "center",
              maxWidth: 400,
              width: "90%",
              borderRadius: 12,
              backgroundColor: "rgba(255, 255, 255, 0.85)",
              boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
            }}
            bodyStyle={{ padding: "32px" }}
          >
            <Spin size="large" />
            <h2
              style={{
                marginTop: 24,
                fontWeight: "bold",
                fontSize: "20px",
                color: "#1890ff",
                animation: "fadeIn 1.5s ease-in-out",
              }}
            >
              Memuat Aplikasi Deteksi Dini Kanker Anak...
            </h2>
          </Card>
        </div>
      ) : (
        <IndikatorKankerAnak />
      )}
    </div>
  );
}

export default App;
